import { mount } from 'svelte';
import Form from './templates/Form.svelte';

const ageGroups = window.ageGroups;
const user = window.user;
const profileUrl = window.profileUrl;

export const initRequestActivity = () => {
  const requestActivityElement = document.querySelector('#js-request-activity-form');

  if (!requestActivityElement) return;

  mount(Form, {
    target: requestActivityElement,
    props: {
      ageGroups,
      user,
      profileUrl,
    },
  });
};
